import { connect } from "react-redux";

// Actions
import {
  createInvoiceUpdateSendLog,
  deleteInvoice,
  getInvoiceConfig,
  getInvoiceDetails,
  isMailSendFromEdit,
  sendInvoiceEmail,
} from "../invoiceActions";
import InvoiceClientView from "./InvoiceClientView";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  isLoading: state.invoice.isLoading,
  invoiceDetails: state.invoice.invoiceDetails,
  profileData: state.profile.profileData,
  invoiceConfig: state.invoice.invoiceConfig,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getInvoiceDetails: details => dispatch(getInvoiceDetails({ ...details })),
  createInvoiceUpdateSendLog: details =>
    dispatch(createInvoiceUpdateSendLog({ ...details })),
  sendInvoiceEmail: details => dispatch(sendInvoiceEmail({ ...details })),
  deleteInvoice: details => dispatch(deleteInvoice({ ...details })),
  isMailSendFromEdit: details => dispatch(isMailSendFromEdit(details)),
  getInvoiceConfig: details => dispatch(getInvoiceConfig({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceClientView);
